module.exports = __webpack_public_path__ + "static/media/slow-down.5f67f91e.m4a";